export enum SearchEnum {
  FirstPage = 48,
  PerPage = 24,
}
